import { ResponseMapDto } from './responsemapdto';
import { MVPDtoImpl, MVPDto } from './mvpdto';

export interface MiddlewareDto extends MVPDto
{
    getMessage(): string;
    getRespTime() : string;
    getStatusCode() : string;
    getResponseMap() : ResponseMapDto;
}

export abstract class MiddlewareDtoImpl extends MVPDtoImpl implements MiddlewareDto
{
    private message: string;
    private respTime: string;
    private statusCode : string;
    private responseMap : ResponseMapDto;

    getMessage(): string 
    {
        return this.message;
    }
    setMessage(message: string)
    {
        this.message = message;
    }

    getRespTime(): string 
    {
        return this.respTime;
    }
    setRespTime(respTime: string)
    {
        this.respTime = respTime;
    }

    getStatusCode(): string 
    {
        return this.statusCode;
    }
    setStatusCode(statusCode: string)
    {
        this.statusCode = statusCode;
    }

    getResponseMap(): ResponseMapDto 
    {
        return this.responseMap;
    }
    setResponseMap(responseMap: ResponseMapDto)
    {
        this.responseMap = responseMap;
    }
}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/middlewaredto.tsx